import { BannerAdminSettings } from '@features/banner/components/BannerAdminSettings'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { hasPermission } from '@features/rbac/permissions'

export const Route = createFileRoute('/_layout/admin/banners')({
    beforeLoad: async ({ context }) => {
        if (!hasPermission('banners.manage')) {
            throw redirect({ to: '/unauthorised' })
        }
    },
    component: RouteComponent,
})

function RouteComponent() {
    return <BannerAdminSettings />
}
